import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import AddIcon from '@mui/icons-material/Add';
import { FileUpload, FilterAlt } from "@mui/icons-material"
import { useNavigate } from "react-router-dom";
import Table from "../../../components/Table";
import { useEffect, useState } from "react";
import { deleteData, fetchData, postData } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useSnackbar } from "../../../context/popup";
import UploadFile from "../../Utils/UploadFile";
import { useLoading } from "../../../components/Loading";
import GeneralBranchFilterDialog from "./components/GeneralBranchFilterDialog.js";

const BankBranchList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.generalBranchStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.generalBranchStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.generalBranchStore?.totalPages);

    const [bankBranchData,setBankBranchData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
    const [fileUploading, setFileUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        bankId: "",
        pinCodeId: "",
        cityId: "",
        isActive: "",
    });

    useEffect(() => {        
        fetchBankBranchList();
    },[isRefresh, currentPage, rowsPerPage, search]);

    //Fetch Bank Branch List
    const fetchBankBranchList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/general/branch?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`)
            
            if(response?.success){
                setBankBranchData(response?.data?.items);
                dispatch(setTotalPages(response?.data?.totalPages));
            }
            else{
                //throw error
                showSnackbar("Error Fetching Bank Branch Data","error");
            }
        } 
        catch (error) {
            console.error('Error Fetching Bank Branch Data:', error);
            showSnackbar(error?.response?.data?.message || 'Network Error', "error");
        }
        finally{
            setCircleLoading(false);
        }
    };
    
    //bulk file upload api function
    const handleFileUploadSuccess = async (file) => {
        setFileUploading(true)
        setUploadSuccess(false)

        try {
            const formData = new FormData()

            formData.append('file', file)

            const result = await postData(`/reference/master/bulkUpload/general-bank-branch-address`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });        

            if (result?.success) {
                setUploadSuccess(true)
                showSnackbar(result?.message,"success");
                setOpenUploadFileDialog(false);
                setClearFileOnSuccess(true);
                fetchBankBranchList(); 
            }
            else {
                setUploadSuccess(false);
                showSnackbar('Faiiled to upload file', "error")
            }

        } catch (error) {
            const errorMessage = error?.response?.data?.message;                
            console.error('Upload error:', error || errorMessage)
            showSnackbar(errorMessage, "error")
        } 
        finally {
            setFileUploading(false)
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try{
            const response = await deleteData(`/reference/general/bank-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);      
            const responseMessage = response?.message;
            if(response?.success){
                showSnackbar(responseMessage, "success");
            }
            else{
                showSnackbar(responseMessage, "error");
            }
        } 
        catch(error) {
            console.error("Error deleting data:", error);
            showSnackbar(error?.response?.data?.message, "error");
        }
    };

    //Navigate to Form
    const handleAddNewBankBranch = () => {
        navigate(`/general-master/bank-branch-list/bank-branch-details`);
    }

    //Table Mapping
    const bankBranchListTable = {
        columns: [
            { key: "sno", label: "S.No.", renderCell: (row) => row.sno },
            { key: "name", label: "Branch Name", renderCell: (row) => row.name },
            { key: "code", label: "Branch Code", renderCell: (row) => row.code },
            { key: "bankName", label: "Bank", renderCell: (row) => row.bankName },
            { key: "city", label: "City", renderCell: (row) => row.city },
            { key: "createdAt", label: "Created At", renderCell: (row) => row.createdAt },
            {
                key: "active",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],
        rows: bankBranchData?.map((bank, index) => ({
            id: bank?.branch.id,
            sno: index + 1,
            name: bank?.branch?.name || "",
            code: bank?.branch?.code || "",
            bankName: bank?.branch?.bank?.name || "",
            city: bank?.address?.city?.name || "",
            isActive: bank?.branch?.isActive,
            createdAt: bank?.branch?.createdAt,
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/general-master/bank-branch-list/bank-branch-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/general-master/bank-branch-list/bank-branch-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };


  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Bank Branch List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Branches associated with their respective banks.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt/>}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                    Filter
                    </MaterialButton>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FileUpload/>}
                    onClick={() => setOpenUploadFileDialog(true)}>
                        Bulk Upload
                    </MaterialButton>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleAddNewBankBranch()}
                    >
                        Bank Branch
                    </MaterialButton>
                </Stack>
            </Stack>
        )} 
        />
        <CardContent>
            <Table
            columns={bankBranchListTable?.columns}
            data={bankBranchListTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel="No Bank Branches found"
            handleSearch={handleSearch}
            />
        </CardContent>
        <UploadFile
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        onUploadSuccess={handleFileUploadSuccess}
        fileTypes={['csv', 'xlsx']}
        fileUploading={fileUploading}
        uploadSuccess={uploadSuccess}
        setUploadSuccess={setUploadSuccess}
        setFileUploading={setFileUploading}
        clearFileOnSuccess={clearFileOnSuccess}
        />
        <GeneralBranchFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchBankBranchList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default BankBranchList